import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Card,
  CardImg,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import moment from 'moment'
import DropZone from 'react-dropzone';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Loader from '../../../commons/loader';
import { DatetimePicker, PaginationTotal, ImageCard } from '../../../commons/controls';
import Service from '../services';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';
import Lib from '../../../commons/lib';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './SlideshowTooltips';
import ProgressButton from '../../../commons/ProgressButton';

class SlideshowContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modositas: false,
      angolNyelv: false,
      currentRow: {},
      enums: [],
      helyszin: {},
      helyszinek: [],
      helyszinid: {},
      ujtab: true,
      modalNezet: false,
      modalSlideshow: false,
      modalSlideshowModosit: false,
      modalSlideshowTorles: false,
      slideshow: {},
      slideshowJson: [],
      slideshowModositObj: {},
      tipus: '',
      img: null,
      kezdet: null,
      vege: null,
      poziciok: [],
      pozicio: null,
      imgLoaded: false,
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDE']
      tableStatus: 'HIDE',
      helyszinOptions: [],
      // ujtab: 'true'

      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
      sortButtonLoading: false,
    };
    this.segedTomb = [];
    this.options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 }
      ]
    };
    this.defaultPozicio = null;
  }

  componentDidMount() {
    this.selected = false;

    this.getHelyszinek();
    this.getPoziciok();
    this.checkAngolNyelv();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '1' && this.props.activeTab === '1') {
      this.getHelyszinek();
    }
  }

  checkAngolNyelv = () => {
    Service.getAngolNyelv((err, res) => {
      if (!err) {
        this.setState({ angolNyelv: res[0] });
      }
    });
  }

  getPoziciok = () => {
    Service.listPosEnum((err, res) => {
      if (!err) {
        this.defaultPozicio = res[0].find(pozicio => pozicio.name === 'KOZEP');
        this.setState({ poziciok: res[0] });
      }
    });
  }

  handleSlideshowEditClick = (id) => {
    this.setState((prevState) => {
      let result = this.kepValasztasHigh(prevState, id, false);
      console.log('result');
      console.log(JSON.stringify(result));
      console.log(result);
      return ({
        slideshowModositObj: result.obj,
        img: result.img,
        url: result.obj && result.obj.url,
        kezdet: result.obj && result.obj.kezdet,
        vege: result.obj && result.obj.vege,
        // ujtab: result.obj && result.obj.ujtab,
        pozicio: result.obj && result.obj.pozicio,
        modositas: true
      });
    }, () => {
      this.toggleSlideshowModosit();
    });
  }

  handleSlideshowDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleSlideshowTorles();
  }

  handleViewClick = (id) => {
    this.toggleNezet(id);
  }

  handleSlideshow = (id, rowObj, rowIndex, plus) => {
    let mostani = this.state.slideshowJson.find((element) => {
      return element === rowObj;
    });
    let masik = this.state.slideshowJson[rowIndex + plus];
    let sorszamseged = mostani.sorszam;
    mostani.sorszam = masik.sorszam;
    masik.sorszam = sorszamseged;
    this.state.slideshowJson.sort((a, b) => {
      return a.sorszam - b.sorszam;
    });
    this.setState({ slideshowJson: this.state.slideshowJson });
  }

  iconFormatter = (cell, rowObj, rowIndex) => {
    return (
      <div>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleViewClick(cell)} />
        <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleSlideshowEditClick(cell)} />
        <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleSlideshowDeleteClick(cell)} />
        <Button style={{ visibility: rowIndex === 0 ? 'hidden' : 'visible' }} className="table-action-icon" id={'action-view-' + cell + 'fel'} onClick={() => { this.handleSlideshow(cell, rowObj, rowIndex, -1) }}>
          <i class="fa fa-arrow-up" />
        </Button>
        <Button style={{ visibility: (rowIndex === this.state.slideshowJson.length - 1) ? 'hidden' : 'visible' }} className="table-action-icon" id={'action-view-' + cell + 'le'} onClick={() => { this.handleSlideshow(cell, rowObj, rowIndex, 1) }}>
          <i class="fa fa-arrow-down" />
        </Button>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'fel'} delay={0}>Eltolás felfele</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'le'} delay={0}>Eltolás lefele</UncontrolledTooltip>
      </div>
    );
  }

  statusFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-default">Nem</span>;
  }

  getHelyszinek = () => {
    Service.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach(e => options.push(<option key={e.id} value={e.id}>{e.nev}</option>));

        this.setState({
          helyszinek: res[0],
          helyszinOptions: options,
          helyszinid: res[0].length === 1 ? res[0][0].id : '',
          helyszin: res[0].length === 1 ? res[0][0] : {}
        });

        if (res[0].length === 1) {
          this.updateTable();
        }
      }
    });
  };

  handleHelyszinSelectChange = (e) => {
    const { target } = e;
    const { value } = target;
    this.setState({
      helyszinid: value,
      helyszin: this.state.helyszinek.find(helyszin => { return helyszin.id == value })
    }, () => {
      if (value !== '') this.updateTable();
      else this.setState({ slideshowJson: [], tableStatus: 'HIDE' });
    });
  }

  handleSlideshowTipusSelectChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({
      tipus: value,
    });
  }

  getSlideshowList = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Service.listSlideshow(this.state.helyszinid, (err, res) => {
        if (!err) {
          this.setState({ slideshowJson: res[0], tableStatus: res[0].length > 0 ? 'TABL' : 'DATA' });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  renderSlideshowTipusOptions = () => {
    return this.state.enums.map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
  }

  renderTipusok = () => {
    let tipusok = {};
    this.state.enums.forEach(e => Object.assign(tipusok, { [JSON.stringify(e)]: e.caption }));
    return tipusok;
  }

  updateTable = () => {
    this.getSlideshowList();
  }

  kepValasztasHigh = (prevState, id, isView) => {
    this.setState({ imgLoaded: false });
    let result = {};
    let maxMeret = 0;
    Service.getSlideshow(id, (err, res) => {
      if (!err) {
        let obj = res[0];
        if (res[0].objects) {
          for (let i = 0; i < res[0].objects.length; i++) {
            let object = res[0].objects[i];
            if (object.length > maxMeret) {
              maxMeret = object.length;
              result.img = object;
              this.setState({ img: object }, () => {
                let img2 = this.state.img;
                if (res[0] != null && res[0].objects != null && res[0].objects[0] != null)
                  img2.content = res[0].objects[0].content;
                else img2.content = null;
                this.setState({ img: img2 });
                this.setState({ imgLoaded: true });
              });
            }
          }

          if (isView) {
            obj.helyszin = this.state.helyszinek.find(x => x.id === obj.helyszinid).nev;
            this.setState({ viewObj: obj });
          } else {
            this.setState({ slideshowModositObj: obj });
          }
        }
        result.obj = obj;
        this.setState({ pozicio: obj.pozicio });
      }
      this.setState({ imgLoaded: true });
    });

    return result;
  }

  toggleNezet = (id) => {
    this.setState((prevState) => {
      let result;
      if (prevState.modalNezet === false)
        result = this.kepValasztasHigh(prevState, id, true);
      let bezar = prevState.modalNezet == true;
      return ({
        modalNezet: !prevState.modalNezet,
        img: bezar ? null : result && result.img,
        url: bezar ? null : result && result.obj && result.obj.url,
        pozicio: bezar ? null : result && result.obj && result.obj.pozicio,
        // ujtab: bezar ? null : result && result.obj && result.obj.ujtab
      });
    });
  }

  toggleSlideshow = () => {
    this.setState((prevState) => { return ({ modalSlideshow: !prevState.modalSlideshow, img: null, kezdet: null, vege: null, pozicio: this.defaultPozicio, url: null, modositas: false, ujtab: true }); });
  }

  toggleSlideshowModosit = () => {
    if (this.state.slideshowModositObj == null)
      this.setState({ kezdet: null, vege: null });
    this.setState((prevState) => { return ({ modalSlideshowModosit: !prevState.modalSlideshowModosit
      /*, img: prevState.modalSlideshowModosit === true ? null : this.state.img, /*pozicio: prevState.modalSlideshowModosit === true ? null : this.state.pozicio*/ }); });
  }

  toggleSlideshowTorles = () => {
    this.setState((prevState) => { return ({ modalSlideshowTorles: !prevState.modalSlideshowTorles }); });
  }

  toggleKepModal = () => {
    this.setState(prevState => ({ kepModal: !prevState.kepModal }));
  }

  onDropKep = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = this.state.img || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          //id: Lib.Browser.uuidv4(),
        });
        this.setState({ img: files[0] });
      };
      reader.readAsBinaryString(file);
    });
  }

  addSlideshow = (event, slideshowObj) => {
    let objects = [];
    if (this.state.img !== null)
      objects.push(this.state.img);
    slideshowObj.helyszinid = this.state.helyszinid;
    slideshowObj.kezdet = TimeFormatter.formatDateTime(this.state.kezdet);
    slideshowObj.vege = TimeFormatter.formatDateTime(this.state.vege);
    slideshowObj.objects = objects;
    slideshowObj.pozicio = this.state.pozicio.name;
    slideshowObj.ujtab = this.state.ujtab;
    // slideshowObj.ujtab = this.state.ujtab ? this.state.ujtab == "true" : "true";
    this.setState({ addButtonLoading: true });
    Service.addSlideshow(slideshowObj, (err) => {
      if (!err) {
        this.toggleSlideshow();
        this.updateTable();
        this.props.globals.addSuccess('Slideshow hozzáadva!');
      }
      this.setState({ addButtonLoading: false });
    });
  }

  editSlideshow = (event, slideshowModositObj) => {
    let objects = [];
    if (this.state.img !== null)
      objects.push(this.state.img);
    this.state.slideshowModositObj.nev = slideshowModositObj.nev;
    this.state.slideshowModositObj.leiras = slideshowModositObj.leiras;
    this.state.slideshowModositObj.objects = objects;
    this.state.slideshowModositObj.kezdet = TimeFormatter.formatDateTime(this.state.slideshowModositObj.kezdet);
    this.state.slideshowModositObj.vege = TimeFormatter.formatDateTime(this.state.slideshowModositObj.vege);
    this.state.slideshowModositObj.pozicio = this.state.pozicio.name;
    this.state.slideshowModositObj.url = slideshowModositObj.url;
    this.state.slideshowModositObj.ujtab = slideshowModositObj.ujtab;
    if (this.state.angolNyelv == true) {
      this.state.slideshowModositObj.nevangol = slideshowModositObj.nevangol;
      this.state.slideshowModositObj.leirasangol = slideshowModositObj.leirasangol;
    }
    this.setState({ modifyButtonLoading: true });
    Service.modifySlideshow(this.state.slideshowModositObj, (err) => {
      if (!err) {
        this.toggleSlideshowModosit();
        this.updateTable();
        this.props.globals.addSuccess('Slideshow módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteSlideshow = () => {
    this.toggleSlideshowTorles();
    this.setState({ deleteButtonLoading: true });
    Service.deleteSlideshow(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.setState({ currentRow: [] });
        this.props.globals.addSuccess('Slideshow törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  handleDateInputChange = (e, v, name) => {
    if (v === '')
      v = null;
    if (this.state.slideshowModositObj)
      this.state.slideshowModositObj[name] = v;
    this.setState({
      [name]: v
    });
  }

  handlePozicioChange = (pozicio) => {
    if (pozicio) {
      this.setState({ pozicio: pozicio });
    } else {
      this.setState({ pozicio: [] });
    }
  }

  helyszinValaszto = () => {
    return (
      <RFForm  onSubmit={() => {}}>
        <RFField
          type="select"
          name="formHelyszin"
          label="Helyszín neve:"
          value={this.state.helyszinid}
          onChange={this.handleHelyszinSelectChange}
          defaultSelect={<option value=''>Válassz helyszínt...</option>}
          selectOptions={this.state.helyszinOptions}
        />
      </RFForm>
    );
  }

  idopontValaszto = (name, label, value) => {
    return (
      <DatetimePicker
        label={label}
        //formatDate="YYYY-MM-DD HH:mm"
        name={name}
        id={name}
        error="Érvénytelen dátum"
        value={value && new Date(value)}
        // onChange={(e, v) => this.handleDateInputChange(e, v, name)}
        onChange={(e,v) => {this.handleDateChange(e,v,'FORMKEZDETE', name)}}
        onSelect={(e,v) => { this.selected = true }}
        timePrecision="seconds"
      />
    );
  }

  handleDateChange = (e,v,type, name) => {
    let helper = null;
    if(this.selected) {
      this.selected = false;
      switch (name) {
        case 'kezdet':
          if(this.state.modositas) {
            this.state.slideshowModositObj[name] = v;
            helper = JSON.parse(JSON.stringify(this.state.slideshowModositObj));
            helper[name] = (moment(e).startOf('day'));
            this.setState({ slideshowModositObj: helper });
          } else {
            this.setState({ [name]: (moment(e).startOf('day')) });
          }
          break;
        case 'vege':
          if(this.state.modositas) {
            helper = JSON.parse(JSON.stringify(this.state.slideshowModositObj));
            helper[name] = (moment(e).endOf('day'));
            this.setState({ slideshowModositObj: helper });
          } else {
            this.setState({ [name]: (moment(e).endOf('day')) });
          }
          break;
        default:
          break;
      }
    } else {
      switch (name) {
        case 'kezdet':
          if(this.state.modositas) {
            helper = JSON.parse(JSON.stringify(this.state.slideshowModositObj));
            helper[name] = (v === '' ? null : e);
            this.setState({ slideshowModositObj: helper });
          } else {
            this.setState({ [name]: (v === '' ? null : e) });
          }
          
          break;
        case 'vege':
          if(this.state.modositas) {
            helper = JSON.parse(JSON.stringify(this.state.slideshowModositObj));
            helper[name] = (v === '' ? null : e);
            this.setState({ slideshowModositObj: helper });
          } else {
            this.setState({ [name]: (v === '' ? null : e) });
          }
          break;
        default:
          break;
      }
    }
  }

  pozicioValaszto = () => {
    return (
      <div style={{ paddingBottom: 10 }}>
        <SelectField
          label={'Kép igazítása: '}
          name="poziciovalaszto"
          id="poziciovalaszto"
          placeholder="Válassz igazítást..."
          noOptionsMessage={() => 'Nincs választható pozíció'}
          ignoreAccents={false}
          options={this.state.poziciok}
          value={this.state.pozicio}
          onChange={this.handlePozicioChange}
          getOptionLabel={option => option.caption}
          getOptionValue={option => option}
          required
        />
      </div>
    );
  }

  rendez = () => {
    let rendezesBean = {};
    rendezesBean.idk = this.state.slideshowJson.map((element) => {
      return element.id;
    });
    rendezesBean.helyszinid = this.state.helyszinid;
    this.setState({sortButtonLoading: true});
    Service.rendezSlideshow(rendezesBean, (err, res) => {
      if (!err) {
        this.props.globals.addSuccess('Sorrend sikeresen elmentve!');
        this.updateTable();
      }
      this.setState({sortButtonLoading: false});
    });
  }

  renderAdatok = () => {
    return (
      <div>
        <b>Helyszín neve: </b>{this.state.viewObj.helyszin}<br />
        <b>Név: </b>{this.state.viewObj.nev}<br />
        {this.state.angolNyelv == true ? 
          <div><b>Név (angol): </b>{this.state.viewObj.nevangol}<br /></div>
          : <div />
        }
        <b>URL: </b>{this.state.viewObj.url}<br />
        <b>URL megnyitása új oldalon: </b>{this.state.viewObj.ujtab ? "Igen" : "Nem"}<br />
        <b>Kezdete: </b>{this.state.viewObj.kezdet}<br />
        <b>Vége: </b>{this.state.viewObj.vege}<br />
        <b>Kép igazítása: </b>{this.state.viewObj.pozicio.caption}<br />
        <b>Leírás: </b>{this.state.viewObj.leiras}<br />
        {this.state.angolNyelv == true ? 
          <div><b>Leírás (angol): </b>{this.state.viewObj.leirasangol}<br /></div>
          : <div />
        }
        <br />
        <h6>Kép:</h6><br />
        <Card inverse style={{ backgroundColor: "#000" }} >
          <CardImg
            src={this.state.img ? this.state.img.src ? this.state.img.src : "data:image/bmp;base64," + this.state.img.content : ''}
          />
        </Card>
      </div>
    );
  }


  renderTable = () => {
    const columns = [
      {
        dataField: 'nev',
        text: 'Név',
      },
      {
        dataField: 'url',
        text: 'Hivatkozás',
      },
      {
        dataField: 'kezdet',
        text: 'Mikor látható',
      },
      {
        dataField: 'vege',
        text: 'Meddig látható',
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    if (this.state.angolNyelv == true) {
      columns.splice(1, 0, {
        dataField: 'nevangol',
        text: 'Név (angol)',
      });
    }

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.slideshowJson}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-3">
            {this.helyszinValaszto()}
          </div>
        </div>
        <div className="row">
          {(this.state.tableStatus === 'DATA' || this.state.tableStatus === 'TABL') &&
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={this.toggleSlideshow}>Új slideshow hozzáadása</Button>
            </div>
          }
        </div>
        <div className="row">
          <div className="col-md-12">
            {(this.state.tableStatus === 'TABL' ? this.renderTable() : this.state.tableStatus === 'NETW' ? <NetworkEmptyState hasImage submitClick={this.updateTable} /> : this.state.tableStatus === 'DATA' ? <DataEmptyState hasImage submitClick={this.updateTable} /> : this.state.tableStatus === 'LOAD' ? <Loader /> : <div />)}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2" style={{ float: 'right' }}>
            {(this.state.tableStatus === 'TABL' ?
              <ProgressButton loading={this.state.sortButtonLoading} type="button" id="rendez" className="btn-cursor-pointer" color="success" onClick={this.rendez} style={{ paddingLeft: 10 }}><i className="fa fa-check" style={{ paddingLeft: 0, paddingRight: 5 }} />Sorrend mentése</ProgressButton>
              : <div />)}
          </div>
        </div>
        <Modal isOpen={this.state.modalSlideshow} toggle={this.toggleSlideshow} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={this.addSlideshow}
            title="Slideshow felvétel"
            footer={
              <>
                <ProgressButton loading={this.state.addButtonLoading} color="primary">Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleSlideshow}>Mégsem</Button>
              </>
            }
          >
            <div className="row">
              <div className="col-md-12">
                <RFField
                  name="nev"
                  label="Név: *"
                  maxLength={120}
                  required
                />
              </div>
              {this.state.angolNyelv == true ?
                <div className="col-md-12">
                  <RFField
                    name="nevangol"
                    label="Név (angol): *"
                    maxLength={120}
                    required
                  />
                </div>
                : <div />
              }
            </div>
            <div className="row">
              <div className="col-md-12">
                <RFField
                  type="textarea"
                  name="leiras"
                  label="Leírás:"
                  maxLength={360}
                />
              </div>
              {this.state.angolNyelv == true ?
                <div className="col-md-12">
                  <RFField
                    type="textarea"
                    name="leirasangol"
                    label="Leírás (angol):"
                    maxLength={360}
                  />
                </div>
              : <div />}
            </div>
            <div className="row" style={{ paddingBottom: 10 }}>
              <div className="col-md-12">
                <RFField
                  label="URL: *"
                  // onChange={(e, v) => { this.setState({ url: v }) }}
                  // value={this.state.url}
                  name="url"
                />
              </div>
            </div>
            <div className="row" style={{ paddingBottom: 10 }}>
              <div className="col-md-12">
                <Label>URL megnyitása új oldalon: *</Label>
                <RFField
                  type="select"
                  name="ujtab"
                  value={this.state.ujtab}
                  onChange={(e, v) => this.setState({ ujtab: v })}
                  selectOptions={
                    <>
                      <option value='true'>Igen</option>
                      <option value='false'>Nem</option>
                    </>
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.idopontValaszto("kezdet", 'Kezdet: *', this.state.kezdet)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.idopontValaszto("vege", 'Vége:', this.state.vege)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.pozicioValaszto()}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Label >Kép: *<CustomTooltip text={getTooltip('kep')} id="kepTT" /></Label>
                {!this.state.img &&
                  <DropZone id="img" onDrop={this.onDropKep} className="custom-dropzone" accept="image/*">
                    {({getRootProps, getInputProps}) => (
                      <div {...getRootProps({ className: 'custom-dropzone'})}>
                        <input {...getInputProps()} />
                        <div className="dropzone-text">
                          {'Kép feltöltése!'}
                        </div>
                      </div>
                  )}
                  </DropZone>
                }
                {this.state.img &&
                  <ImageCard
                    mime={this.state.img.mime}
                    content={this.state.img.content}
                    src={this.state.img.src}
                    poster
                    onViewClick={this.toggleKepModal}
                    onDeleteClick={() => { this.setState({ img: null }) }}
                    noStyle
                  />
                }
              </div>
            </div>
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalSlideshowModosit} toggle={this.toggleSlideshowModosit} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={this.editSlideshow}
            title="Slideshow módosítás"
            footer={
              <>
                {this.state.imgLoaded ? <div><ProgressButton loading={this.state.modifyButtonLoading} color="primary">Mentés</ProgressButton>{' '}</div> : <div />}
                <Button type="button" color="secondary" onClick={this.toggleSlideshowModosit}>Mégsem</Button>
              </>
            }
          >
            {!this.state.imgLoaded ? <Loader /> :
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <RFField
                      name="nev"
                      label="Név: *"
                      maxLength={120}
                      value={this.state.slideshowModositObj.nev}
                      required
                    />
                  </div>
                  {this.state.angolNyelv == true ?
                    <div className="col-md-12">
                      <RFField
                        name="nevangol"
                        label="Név (angol): *"
                        maxLength={120}
                        value={this.state.slideshowModositObj.nevangol}
                        required
                      />
                    </div>
                    : <div />
                  }
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <RFField
                      type="textarea"
                      name="leiras"
                      label="Leírás:"
                      maxLength={360}
                      value={this.state.slideshowModositObj.leiras}
                    />
                  </div>
                  {this.state.angolNyelv == true ?
                    <div className="col-md-12">
                      <RFField
                        type="textarea"
                        name="leirasangol"
                        label="Leírás (angol):"
                        maxLength={360}
                        value={this.state.slideshowModositObj.leirasangol}
                      />
                    </div>
                  : <div />}
                </div>
                <div className="row" style={{ paddingBottom: 10 }}>
                  <div className="col-md-12">
                    <RFField
                      name="url"
                      label="URL: *"
                      // onChange={(e, v) => { this.setState({ url: v }) }}
                      value={this.state.slideshowModositObj.url}
                      required
                    />
                  </div>
                </div>
                <div className="row" style={{ paddingBottom: 10 }}>
                  <div className="col-md-12">
                    <Label>URL megnyitása új oldalon: *</Label>
                    <RFField
                      type="select"
                      // === ellenőrzés miatt string típus szükséges, boolean és {true}/{false} value nem jó
                      value={this.state.slideshowModositObj.ujtab + ''}
                      name="ujtab"
                      onChange={(e, v) => this.setState({ ujtab: v })}
                      selectOptions={
                        <>
                          <option value="true">Igen</option>
                          <option value="false">Nem</option>
                        </>
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {this.idopontValaszto("kezdet", 'Kezdet: *', this.state.slideshowModositObj.kezdet)}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {this.idopontValaszto("vege", 'Vége:', this.state.slideshowModositObj.vege)}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {this.pozicioValaszto()}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <Label >Kép: *<CustomTooltip text={getTooltip('kep')} id="kepTT" /></Label>
                    {!this.state.img &&
                      <DropZone id="img" onDrop={this.onDropKep} className="custom-dropzone">
                        {({getRootProps, getInputProps}) => (
                          <div {...getRootProps({ className: 'custom-dropzone'})}>
                            <input {...getInputProps()} />
                            <div className="dropzone-text">
                              {'Kép feltöltése!'}
                            </div>
                          </div>
                        )}
                      </DropZone>
                    }
                    {this.state.img &&
                      <ImageCard
                        mime={this.state.img.mime}
                        content={this.state.img.content}
                        src={this.state.img.src}
                        poster
                        onViewClick={this.toggleKepModal}
                        onDeleteClick={() => { this.setState({ img: null }) }}
                        noStyle
                      />
                    }
                  </div>
                </div>
              </div>
            }
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalSlideshowTorles} toggle={this.toggleSlideshowTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a slideshowt?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} color="primary" onClick={this.deleteSlideshow}>OK</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleSlideshowTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
          <ModalHeader >Slideshow információ</ModalHeader>
          <ModalBody>{this.state.modalNezet ? this.state.imgLoaded ? this.renderAdatok(this._currentViewId) : <Loader /> : <div />}</ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={this.toggleNezet}>Vissza</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.kepModal} toggle={this.toggleKepModal} backdrop="static">
          <Card style={{ marginBottom: "0", border: "none" }}>
            <RFForm  onSubmit={() => {}}>
              {this.state.img &&
                <React.Fragment>
                  <CardImg
                    src={this.state.img.src ? this.state.img.src : "data:image/bmp;base64," + this.state.img.content}
                    onClick={this.toggleKepModal} />
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <RFField
                      placeholder="Alt tag..."
                      onChange={(e, v) => { this.setState(prevState => ({ img: { ...prevState.img, alt: v } })) }}
                      value={this.state.img.alt}
                      disabled={this.state.img.id}
                      name="imgAltTag"
                    />
                    <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.toggleKepModal}>
                      OK
                    </Button>
                  </div>
                </React.Fragment>
              }
            </RFForm>
          </Card>
        </Modal>
      </div>
    );
  }
};

export default SlideshowContent;
